module.exports = __webpack_public_path__ + "img/assembler-3.cc2035b3.png";